const REFERRAL_CODE_KEY = 'as_referral_code';

export const storeReferralCode = (code) => localStorage.setItem(REFERRAL_CODE_KEY, code);

export const getStoredReferralCode = () => localStorage.getItem(REFERRAL_CODE_KEY);

export const clearStoredReferralCode = () => localStorage.removeItem(REFERRAL_CODE_KEY);
